module.exports = __webpack_public_path__ + "images/videoCaseStudy-berriFit-challenge-float01.jpg?h=2c7d72c98139aef43263171811e1045d";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/berriFit/videoCaseStudy-berriFit-challenge-float01.jpg
// module id = 2095
// module chunks = 12 15